var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeNeedYourHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5170.079,
    height: 5018.103,
    viewBox: "0 0 5170.079 5018.103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_906",
    "data-name": "Group 906",
    transform: "translate(12244.194 -2864.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_314",
    "data-name": "Ellipse 314",
    transform: "translate(-11157.78 6339.791)",
    fill: "none",
    stroke: "#fee135",
    strokeWidth: 1,
    strokeDasharray: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.583,
    cy: 15.583,
    r: 15.583,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.583,
    cy: 15.583,
    r: 15.083,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path320",
    d: "M9006.408-856.949c4.656,40.589,12.43,77.268,24.554,106.466L8057.526-586.329s-38.084-45.063-72.917-112.907c-3.8-7.407-7.6-15.058-11.269-23.014-19.653-42.435-36.679-91.836-42.74-143.756-.306-2.457-.611-4.9-.795-7.358-4.534-46.407-.061-94.647,19.1-141.617,2.762-6.734,5.818-13.408,9.191-20.081a282.285,282.285,0,0,1,18.113-30.726,308.991,308.991,0,0,1,21.315-27.989,367.51,367.51,0,0,1,51.247-48.912l982.187-176.828s-4.413,26.082-9.924,67.783c-1.04,7.9-2.079,16.341-3.24,25.287q-1.557,13.493-3.251,28.282c-.917,8.14-1.833,16.6-2.688,25.287-3.924,38.389-7.468,81.557-9.5,125.936-.365,8.274-.732,16.6-.977,24.921-1.59,47.7-1.161,95.943,2.578,140.639.673,8.262,1.468,16.475,2.445,24.432",
    transform: "translate(-16229.812 8302.666)",
    fill: "#f9e4dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path322",
    d: "M9008.043-817.113,7986.244-659.4l-24.31,3.74a10.185,10.185,0,0,1-1.894.122,12.284,12.284,0,0,1-12.124-10.352,12.276,12.276,0,0,1,10.279-13.958l16.781-2.567L9005.6-841.545c.673,8.262,1.468,16.475,2.445,24.432",
    transform: "translate(-16231.445 8262.829)",
    fill: "#edd1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path324",
    d: "M9002.486-1022.158c-.367,8.274-.733,16.6-.979,24.921L7943.765-834a9.873,9.873,0,0,1-1.895.122,12.094,12.094,0,0,1-11.146-7.345,10.182,10.182,0,0,1-.917-3.007,11.546,11.546,0,0,1,.122-4.351,12.2,12.2,0,0,1,10.108-9.607l1062.449-163.971",
    transform: "translate(-16229.935 8277.883)",
    fill: "#edd1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path326",
    d: "M9024.274-1245.57c-1.039,7.9-2.077,16.341-3.239,25.287L7981.111-1059.82a7.019,7.019,0,0,1-1.662.2h-.183a12.28,12.28,0,0,1-12.112-10.413,12.224,12.224,0,0,1,10.217-13.958l23.393-3.618,1023.51-157.958",
    transform: "translate(-16233.048 8296.503)",
    fill: "#edd1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path328",
    d: "M9016.183-1187.13c-.917,8.14-1.833,16.6-2.689,25.287L7961.934-999.6c-.672.061-1.283.122-1.894.122a12.436,12.436,0,0,1-9.5-4.473,12.253,12.253,0,0,1-2.627-5.879,12.25,12.25,0,0,1,10.279-13.958l1.54-.245,1056.448-163.1",
    transform: "translate(-16231.445 8291.633)",
    fill: "#edd1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path330",
    d: "M7785.744-560.7H4608.405a60.977,60.977,0,0,1-50.086-26.571c-121.1-175.851-116.818-343.549-2.139-527.039a69.243,69.243,0,0,1,58.654-32.388l294.625-1.161,219.312-.794,2656.973-10.291c-172.539,190.847-158.886,390.934,0,598.244",
    transform: "translate(-15941.492 8289.283)",
    fill: "#896060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path332",
    d: "M5079.215-793.461c2.688,81.668,18.37,162.431,43.461,233.7H4917.395a989.053,989.053,0,0,1-33.99-227.33c-4.277-130.91,16.6-252.568,60.561-359.829l219.312-.794c-76.778,126.241-86.886,268.1-84.062,354.256",
    transform: "translate(-15975.999 8288.348)",
    fill: "#ffdaa9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path334",
    d: "M7462.569-793.461c2.689,81.668,18.37,162.431,43.474,233.7H7300.75a988.332,988.332,0,0,1-33.977-227.33c-4.291-130.91,16.585-252.568,60.547-359.829l219.312-.794c-76.779,126.241-86.874,268.1-84.063,354.256",
    transform: "translate(-16174.642 8288.348)",
    fill: "#ffdaa9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path336",
    d: "M5596.255-1303.907l-902.414,152.885-105.746-.245v-.44c.184-7.162,48.094-20.57,55.439-21.853L5591.109-1334.1a15.557,15.557,0,0,1,6.735.367,15.392,15.392,0,0,1,10.9,12.185,15.281,15.281,0,0,1-12.49,17.636",
    transform: "translate(-15951.432 8303.898)",
    fill: "#7c4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path338",
    d: "M8783.888-1340.823l-1013.72,196.359-3076.555-7.1-105.746-.245h-2.505l2.505-.44,998.052-180.862a106.742,106.742,0,0,1,11.7-1.161c1.161-.061,2.322-.122,3.483-.122l3182.789-6.429",
    transform: "translate(-15951.204 8304.442)",
    fill: "#7c4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path340",
    d: "M8067.856-520.7a15.307,15.307,0,0,1-15.095-12.821,15.312,15.312,0,0,1,12.637-17.588L9067.46-715.2a15.283,15.283,0,0,1,17.573,12.625,15.311,15.311,0,0,1-12.624,17.588L8070.349-520.9a15.8,15.8,0,0,1-2.493.2",
    transform: "translate(-16240.178 8252.317)",
    fill: "#7c4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path342",
    d: "M8067.856-1146.621a15.318,15.318,0,0,1-15.095-12.833,15.294,15.294,0,0,1,12.637-17.575L9067.46-1341.122a15.274,15.274,0,0,1,17.573,12.625,15.292,15.292,0,0,1-12.624,17.575l-1002.06,164.093a14.513,14.513,0,0,1-2.493.208",
    transform: "translate(-16240.178 8304.484)",
    fill: "#7c4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path344",
    d: "M8109.767-1011.553s135.934,60.9,55.488,379.189l138.708-159.656,73.8,84.735s145.577-347.815-86.459-330.1l-181.534,25.837",
    transform: "translate(-16244.946 8279.207)",
    fill: "#d38888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path346",
    d: "M9116.753-1479.735c4.059,35.383,10.842,67.355,21.4,92.8L8289.677-1243.85s-33.2-39.281-63.555-98.412c-3.313-6.453-6.624-13.126-9.826-20.068-17.124-36.984-31.96-80.042-37.24-125.3-.27-2.139-.538-4.266-.7-6.4-3.948-40.455-.048-82.511,16.646-123.443,2.407-5.866,5.072-11.684,8-17.5a249.43,249.43,0,0,1,15.8-26.791,271.326,271.326,0,0,1,18.565-24.383,319.856,319.856,0,0,1,44.672-42.643l856.105-154.12s-3.839,22.733-8.643,59.069c-.9,6.893-1.82,14.251-2.836,22.049q-1.355,11.77-2.823,24.652c-.795,7.1-1.6,14.459-2.347,22.036-3.423,33.464-6.514,71.083-8.275,109.778-.317,7.211-.636,14.459-.854,21.719-1.382,41.579-1.015,83.623,2.248,122.587.587,7.2,1.271,14.361,2.127,21.291",
    transform: "translate(-16250.545 8349.623)",
    fill: "#f9e4dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path348",
    d: "M9118.178-1445.012l-890.632,137.473-21.192,3.251a8.583,8.583,0,0,1-1.65.11,10.69,10.69,0,0,1-10.561-9.02,10.7,10.7,0,0,1,8.959-12.161l14.618-2.249,898.332-138.7c.587,7.2,1.271,14.361,2.126,21.291",
    transform: "translate(-16251.969 8314.9)",
    fill: "#edd1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path350",
    d: "M9113.341-1623.729c-.318,7.211-.637,14.459-.855,21.719l-921.958,142.277a8.443,8.443,0,0,1-1.662.11,10.523,10.523,0,0,1-9.7-6.4,8.789,8.789,0,0,1-.807-2.615,10.106,10.106,0,0,1,.11-3.789,10.632,10.632,0,0,1,8.8-8.384l926.077-142.912",
    transform: "translate(-16250.651 8328.021)",
    fill: "#edd1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path352",
    d: "M9132.333-1818.476c-.9,6.893-1.82,14.251-2.836,22.049l-906.423,139.869a6.507,6.507,0,0,1-1.441.159h-.159a10.708,10.708,0,0,1-10.572-9.069,10.678,10.678,0,0,1,8.91-12.173l20.386-3.141,892.135-137.693",
    transform: "translate(-16253.364 8344.252)",
    fill: "#edd1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path354",
    d: "M9125.278-1767.529c-.795,7.1-1.6,14.459-2.347,22.036l-916.579,141.421a15.836,15.836,0,0,1-1.65.11,10.839,10.839,0,0,1-8.274-3.9,10.61,10.61,0,0,1-2.285-5.121,10.669,10.669,0,0,1,8.959-12.161l1.332-.22,920.845-142.167",
    transform: "translate(-16251.969 8340.006)",
    fill: "#edd1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path356",
    d: "M8052.777-1221.515H5283.312a53.123,53.123,0,0,1-43.657-23.161c-105.55-153.265-101.822-299.44-1.858-459.378a60.33,60.33,0,0,1,51.125-28.233l256.8-1.014,191.152-.7,2315.905-8.959c-150.38,166.342-138.488,340.738,0,521.441",
    transform: "translate(-15999.235 8337.958)",
    fill: "#9bb8bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path358",
    d: "M5693.679-1424.4c2.346,71.193,16.011,141.592,37.888,203.7H5552.636a861.8,861.8,0,0,1-29.626-198.144c-3.728-114.1,14.471-220.143,52.787-313.642l191.152-.7c-66.915,110.047-75.716,233.7-73.271,308.778",
    transform: "translate(-16029.313 8337.144)",
    fill: "#ffdaa9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path360",
    d: "M7771.1-1424.4c2.347,71.193,16.011,141.592,37.888,203.7H7630.045a861.748,861.748,0,0,1-29.614-198.144c-3.74-114.1,14.458-220.143,52.775-313.642l191.165-.7c-66.928,110.047-75.728,233.7-73.271,308.778",
    transform: "translate(-16202.455 8337.144)",
    fill: "#ffdaa9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path362",
    d: "M6144.354-1869.311,5357.78-1736.054l-92.167-.22v-.367c.159-6.245,41.921-17.942,48.326-19.054l825.928-139.93a13.485,13.485,0,0,1,5.867.318,13.437,13.437,0,0,1,9.509,10.621,13.323,13.323,0,0,1-10.89,15.375",
    transform: "translate(-16007.899 8350.697)",
    fill: "#889dba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path364",
    d: "M8922.8-1901.489l-883.594,171.145-2681.624-6.184-92.167-.22h-2.187l2.188-.367,869.928-157.652a91.66,91.66,0,0,1,10.193-1.015c1.015-.049,2.029-.11,3.043-.11l2774.221-5.6",
    transform: "translate(-16007.701 8351.171)",
    fill: "#7c9ca0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path366",
    d: "M8298.688-1186.642a13.332,13.332,0,0,1-13.151-11.183,13.33,13.33,0,0,1,11-15.326l873.423-143.035a13.324,13.324,0,0,1,15.326,11.012,13.346,13.346,0,0,1-11,15.327l-873.434,143.022a13.029,13.029,0,0,1-2.163.183",
    transform: "translate(-16259.579 8305.737)",
    fill: "#889dba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path368",
    d: "M8298.688-1732.214a13.332,13.332,0,0,1-13.151-11.183,13.324,13.324,0,0,1,11-15.326l873.423-143.034a13.324,13.324,0,0,1,15.326,11.012,13.327,13.327,0,0,1-11,15.314L8300.851-1732.4a13.04,13.04,0,0,1-2.164.183",
    transform: "translate(-16259.579 8351.208)",
    fill: "#889dba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path370",
    d: "M9070.52-2010.5c3.142,24.456,8.372,46.554,16.548,64.141l-655.932,98.888S8405.48-1874.62,8382-1915.49c-2.554-4.461-5.108-9.069-7.59-13.872-13.236-25.556-24.713-55.317-28.795-86.605-.208-1.467-.415-2.946-.537-4.424-3.056-27.952-.037-57.016,12.869-85.31,1.857-4.058,3.924-8.079,6.2-12.1a167.767,167.767,0,0,1,12.21-18.516,193.226,193.226,0,0,1,14.349-16.854,238.93,238.93,0,0,1,34.539-29.468l661.824-106.515s-2.971,15.705-6.687,40.822c-.709,4.755-1.405,9.851-2.187,15.241-.7,5.414-1.441,11.1-2.188,17.038-.623,4.9-1.233,10-1.808,15.229-2.652,23.124-5.035,49.132-6.4,75.874-.244,4.974-.488,10-.659,15.009-1.063,28.734-.782,57.8,1.735,84.723.453,4.974.99,9.924,1.65,14.715",
    transform: "translate(-16264.467 8383.48)",
    fill: "#f9e4dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path372",
    d: "M9071.62-1986.506,8383.1-1891.492l-16.378,2.249a7.69,7.69,0,0,1-1.271.073c-4.009,0-7.517-2.579-8.177-6.233-.659-4.021,2.4-7.785,6.931-8.409l11.3-1.552,694.456-95.857c.453,4.974.99,9.924,1.65,14.715",
    transform: "translate(-16265.568 8359.483)",
    fill: "#edd1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path374",
    d: "M9067.877-2110.021c-.244,4.974-.488,10-.66,15.009l-712.728,98.338a7.531,7.531,0,0,1-1.284.073,8.19,8.19,0,0,1-7.5-4.437,5.819,5.819,0,0,1-.624-1.8,6.343,6.343,0,0,1,.085-2.628,7.9,7.9,0,0,1,6.808-5.793l715.906-98.766",
    transform: "translate(-16264.55 8368.551)",
    fill: "#edd1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path376",
    d: "M9082.563-2244.621c-.708,4.755-1.405,9.851-2.187,15.241l-700.727,96.664a5.708,5.708,0,0,1-1.112.11h-.122c-4.01,0-7.554-2.615-8.177-6.27-.7-4.021,2.4-7.773,6.894-8.409l15.754-2.176,689.677-95.161",
    transform: "translate(-16266.646 8379.769)",
    fill: "#edd1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path378",
    d: "M9077.107-2209.408c-.624,4.9-1.235,10-1.808,15.229l-708.574,97.74c-.452.037-.868.073-1.271.073a8.829,8.829,0,0,1-6.4-2.689,7.038,7.038,0,0,1-1.772-3.544c-.659-4.021,2.4-7.81,6.931-8.409l1.038-.147,711.861-98.253",
    transform: "translate(-16265.568 8376.834)",
    fill: "#edd1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path380",
    d: "M8248.007-1832.043H6107.047c-13.493,0-26.069-6.05-33.745-16-81.606-105.928-78.722-206.956-1.443-317.5,8.5-12.136,23.467-19.506,39.514-19.506l198.523-.7,147.777-.489,1790.333-6.2c-116.256,114.973-107.066,235.507,0,360.391",
    transform: "translate(-16070.191 8375.42)",
    fill: "#d38888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path382",
    d: "M6424.288-1972.266a431.843,431.843,0,0,0,29.285,140.786H6315.243a537.663,537.663,0,0,1-22.892-136.948c-2.884-78.857,11.183-152.14,40.8-216.758l147.777-.489c-51.724,76.058-58.544,161.514-56.637,213.409",
    transform: "translate(-16093.442 8374.856)",
    fill: "#ffdaa9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path384",
    d: "M8030.245-1972.266a432.155,432.155,0,0,0,29.3,140.786h-138.33a537.179,537.179,0,0,1-22.9-136.948c-2.885-78.857,11.183-152.14,40.809-216.758l147.777-.489c-51.736,76.058-58.543,161.514-56.648,213.409",
    transform: "translate(-16227.291 8374.856)",
    fill: "#ffdaa9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path386",
    d: "M6780.36-2229.153l-615.747,45.71-71.254-.146v-.257c.134-4.314,32.414-12.393,37.363-13.175l646.18-50.318a11.706,11.706,0,0,1,4.534.22,9.737,9.737,0,0,1,7.346,7.345c.953,5.011-2.812,9.766-8.421,10.621",
    transform: "translate(-16076.889 8380.006)",
    fill: "#c97777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path388",
    d: "M8920.578-2301.995,8237.513-2183.71l-2073.052-4.278-71.254-.147h-1.687l1.688-.257,680.192-62.577c2.6-.367,5.244-.587,7.884-.7.782-.037,1.564-.073,2.359-.073l2136.937-50.257",
    transform: "translate(-16076.735 8384.551)",
    fill: "#c97777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path390",
    d: "M8438.1-1807.941c-4.962,0-9.338-3.2-10.157-7.724-.929-5.035,2.885-9.765,8.507-10.6l675.207-98.852c5.634-.831,10.926,2.579,11.842,7.614s-2.884,9.765-8.507,10.584l-675.205,98.852a11.32,11.32,0,0,1-1.687.122",
    transform: "translate(-16271.452 8353.15)",
    fill: "#c97777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path392",
    d: "M8438.1-2185.006c-4.962,0-9.338-3.214-10.157-7.724-.929-5.035,2.885-9.778,8.507-10.6l675.207-98.852c5.634-.831,10.926,2.579,11.842,7.6s-2.884,9.766-8.507,10.6l-675.205,98.852a11.288,11.288,0,0,1-1.687.122",
    transform: "translate(-16271.452 8384.576)",
    fill: "#c97777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path394",
    d: "M8418.232-2103.633s91.592,36.678,37.387,228.418l93.463-96.175,49.73,51.051s98.095-209.534-58.262-198.865l-122.319,15.571",
    transform: "translate(-16270.655 8369.349)",
    fill: "#896060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path396",
    d: "M8523.367-3096.886s128.282,221.622,191.617,360.513c17.245,37.827,181.84-92.778,191.092-84.014s0-44.708,35.907,9.888c24.444,37.192-188.023,230.068-232.964,229.86-6.245-.024-41.445-27.475-110.487-82.792-21-16.818-133.868-172.918-135.236-273.59-1.821-132.768,60.071-159.865,60.071-159.865",
    transform: "translate(-16274.408 8450.802)",
    fill: "#f7a38f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path398",
    d: "M8556.619-3130.886c81.387,37.791,124.579,143.132,154.45,272.051l-154.45,86.25v-358.3",
    transform: "translate(-16282.188 8453.635)",
    fill: "#f4f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path400",
    d: "M8533.006-3151.025c13.041,91.775-7.565,161.478-45.747,174.739-27.035,9.386-56.882-11.587-93.535-37.338-59.18-41.579-62.517-79.676-116.366-164.02-3.691-5.781-4.73-9.582-3.667-12.687,2.628-7.883,18.687-11.305,39.452-31.264,13-12.491,19.5-88.6,22-127.732.916-13.945,1.308-23.2,1.308-23.2l129.64,76.62,13.676,8.078c0,.012-.012.049-.012.073-.123,1.088-1.455,12.1-2.481,28.526v.037c-.954,15.265-1.687,35.188-.954,56.209.074,2.836.2,5.683.343,8.543.292,5.292.6,9.362.624,9.7.9,9.814,47.055,29.956,55.72,33.708",
    transform: "translate(-16258.575 8473.774)",
    fill: "#ffb7a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path402",
    d: "M8555.007-3252.966c-8.9,5.048-18.687,4.9-38.279,4.62-13.225-.2-83.146-2.835-128.735-59.423-39.307-48.791-47.4-121.28-14.85-178.271,26.107-45.723,83.563-79.932,194.355-72.758.843,5.072,2.151,13.139,3.629,23.038,16.317,109.778,37.521,252.385-16.12,282.794",
    transform: "translate(-16265.213 8489.379)",
    fill: "#ffb7a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path404",
    d: "M8479.994-3237.227c-33.611-13.86-67.259-28.709-90.591-57.712-3.813-4.742-10.449,1.98-6.672,6.673,24.334,30.262,59.691,45.674,94.744,60.132,5.622,2.323,8.066-6.807,2.519-9.093",
    transform: "translate(-16267.603 8467.442)",
    fill: "#ed867e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path406",
    d: "M8606.783-3616.484c-.391,22.4-22.879,38.536-38.682,49.523-76.657,53.2-147.031,24.676-172.087,68.81-9.643,16.94-10.181,40.418-10.512,54.009a165.052,165.052,0,0,0,7.627,53.544l-14.385-.428a60.261,60.261,0,0,0-4.181-7.027c-5.561-8.116-15.876-18.932-26-7.138-14.861,17.318-13.749,30.188-13.749,30.188a248.761,248.761,0,0,1-61.257-8.959c-30.335-8.666-62.614-25.7-72.722-59.216-17.465-57.92,26.461-70.411,44.415-94.33a34.161,34.161,0,0,0,6.759-14.6c6.074-32.706-14.643-45.1-2.481-71.792a63.441,63.441,0,0,1,9.118-14.4c20.435-24.677,57.858-35.994,77.939-29.357,21.548,7.125,29.235,18.932,35.75,21.915,8.3,3.789,12.051,3.5,13.884,3.2a9.4,9.4,0,0,0,3.374-1.418c3.337-2.054,8.665-6.331,21.694-13.787,20.265-11.562,43.218-23.979,68.663-28.99,25.324-5.036,53.143-2.75,83.185,14.959,30.347,17.881,43.95,37.008,43.644,55.292",
    transform: "translate(-16252.201 8500.157)",
    fill: "#51313f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path408",
    d: "M8388.742-3377.057c1.234-17.429-7.822-33.342-21.1-39.233-11.013-4.9-27.01-6.71-43.34,9.851-19.188,19.47-.366,94.733,40.479,67.087,17.367-11.745,23.1-25.63,23.956-37.705",
    transform: "translate(-16262.198 8477.707)",
    fill: "#ffb7a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path410",
    d: "M8356.8-3399.3c-5.39-2.774-10.181,5.366-4.767,8.152a25.678,25.678,0,0,1,14.214,23.418c-.061,6.074,9.387,6.074,9.447,0a35.073,35.073,0,0,0-18.895-31.57",
    transform: "translate(-16264.94 8476.053)",
    fill: "#ed867e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path412",
    d: "M8807.542-1530.154s-10.425,55.342-25.152,81.827-44.488,56.282-43.413,68.92,39.306,44.586,85.261,48.534,125.484,63.408,173.662,77.207c23.148,6.624,42.595,7.5,56.553,6.624,10.585-.672,16-14.41,8.714-22.1-12.088-12.76-30.714-28.734-53.069-35.627-40-12.356-104.742-66.268-110.315-106.5s-2.48-54.963,6.674-98.632-98.913-20.252-98.913-20.252",
    transform: "translate(-16297.386 8320.745)",
    fill: "#ffb7a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path414",
    d: "M8903.259-1538.859c-6.245,10.144-53.947,1.723-95.038-6.148-31.056-5.977-58.348-11.623-61.11-8.727,0,0,1.712-541.607-37.007-565.33s-436.816-308.142-436.816-308.142l189.319-34.3s29.309,10.865,73.161,27.707c123.517,47.495,362.432,142.558,386.669,176.376,53.729,74.945-8.225,700.787-19.176,718.558",
    transform: "translate(-16258.574 8397.845)",
    fill: "#95a5bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path416",
    d: "M8484.8-1364.143s-24.762,83.452-1.246,105.733c22.439,21.254,102.774,89.148,183.771,94.819a9.231,9.231,0,0,1,6.489,15.021c-4.925,6.074-14.251,13.065-31.8,18.908-40.846,13.615-54.461,21.046-111.415-1.234-67.393-26.375-120.058-59.533-148.548-64.373-35.382-6.013-69.518-17.331-65.618-58.189,3.459-36.25,22.048-35.126,32.191-43.327s19.8-54.474,19.8-54.474l116.378-12.882",
    transform: "translate(-16262.146 8306.386)",
    fill: "#ffb7a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path418",
    d: "M8471.366-1400.42c-18.37,9.973-67.173-13.848-99.182-29.247-13.97-6.71-24.763-11.831-28.4-11.831-11.99,0,79.26-600.163,79.26-600.163s-.049-.012-.158-.049a1.294,1.294,0,0,0-.2-.061,3.2,3.2,0,0,0-.354-.11c-4.534-1.491-30.444-9.961-66.78-22.244-.257-.086-.525-.183-.807-.269-70.583-24.921-177.7-66.891-230.606-108.752-97.85-77.365-107.224-140.737-102.849-193.316.795-8.287,1.674-15.913,2.591-22.623.159-1.21.331-2.42.5-3.642.979-.269,2.017-.562,3.068-.855.538-.146,1.088-.305,1.663-.465,1.1-.318,2.212-.623,3.361-.941,3.875-1.088,8.067-2.249,12.515-3.52l37.583-10.572q4.125-1.155,8.323-2.347c12.149,5.194,22.085,9.2,34.637,2.7,19.629-10.144,35.334-19.971,50.539-27.121,11.757-5.524,23.185-9.423,35.908-10.609a88.344,88.344,0,0,1,13.519-.22c32.646,1.894,56.014,20.081,65.987,27.719,3.972,3.031,7.919,5.989,11.891,8.873,157.848,115.388,313.96,125.459,366.735,265.9,18.92,50.416-99.39,689.812-198.742,743.76",
    transform: "translate(-16237.501 8396.623)",
    fill: "#95a5bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path420",
    d: "M8697.285-2184.272c-19.311-22.77-48.387-40.968-72.562-58.079a1045,1045,0,0,0-174.873-99.536,214.017,214.017,0,0,1,19.336-27.17c3.568-4.253-2.543-10.413-6.124-6.135a229.953,229.953,0,0,0-23.173,33.012c-1.076,1.858-.6,4.974,1.552,5.927a1050.147,1050.147,0,0,1,146.763,79.541q36.958,24.126,71.768,51.357c27.951,21.914,49.133,42.251,43.3,81.215-.807,5.463,7.541,7.81,8.359,2.31,3.41-22.782.966-44.354-14.348-62.442",
    transform: "translate(-16272.415 8390.772)",
    fill: "#7f90a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path422",
    d: "M8560.052-2895.4c-13,87.277-49.694,402.1-49.694,402.1-25.568-23.234-236.252,3.227-378.358,24.2-74.688,11.024-130.446,20.557-130.446,20.557s31.557-137.413,51.993-193.133,76.131-207.97,118.847-245.113c15.18-13.212,27.561-53.19,36.947-99.487,14.434-71.242,21.816-157.444,21.5-183.991a11.531,11.531,0,0,1,7.847-11.024l18.6-6.282c53.129,84.369,113,122.575,148.778,140.419,26.424,13.175,60.6,29.724,80.115,15.4,20.105-14.752,10.841-69.922-10.706-120.668,0,0,16.928-.526,34.881,16.805,24.567,23.711,62.688,152.934,49.7,240.212",
    transform: "translate(-16235.927 8458.358)",
    fill: "#f7f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path424",
    d: "M8743.86-3069.406s-5.867,23.833-10.192,20.912c-4.352-2.933,225.924,38.145,225.924,38.145l30.213-103.142s-23.2-6.7-22.073-19.262l-12.553,72.354s-128.759,7.2-211.318-9.007",
    transform: "translate(-16296.94 8453.791)",
    fill: "#fff2ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path426",
    d: "M9010.689-2831.8l-26.5,74.115L8985.4-3042.8l27.439-81.973c2.2-1.479,4.8,1.1,5.207,5.158l-7.357,287.817",
    transform: "translate(-16317.825 8453.161)",
    fill: "#896060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path428",
    d: "M8736.533-2720.638,8945.042-2735s.562-16.341.134-18.761L8952-3019.613c-.281-1.626-5.9-2.8-6.953-3.508l-219.509-23.026c-2.518-1.711-4.437.941-3.483,4.815l10.572,227.941c0,28.881,3.911,92.753,3.911,92.753",
    transform: "translate(-16295.956 8446.616)",
    fill: "#896060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path430",
    d: "M8965.34-3022.174l18.49-13.139-1.209,285.116-17.281,16.146v-288.123",
    transform: "translate(-16316.255 8445.67)",
    fill: "#dbaea2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path432",
    d: "M9014.665-2910.621s20.4-42.154,13.066-46.737,8.677-11.917,1.588-21.547-26.068.465-24.835,10.547,8.934,12.137,7.382,21.645-21.939,36.092-9.569,36.092h12.368",
    transform: "translate(-16319.003 8441.291)",
    fill: "#f7a38f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path434",
    d: "M8765.685-2844.922c-57.175,80.458-143.046,64.764-143.046,64.764-71.463,68.566-431.866,238.464-551.789,207.86-20.508-5.219-21.95-180.2-21.95-180.2-2.286-329.946,189.882-418.361,189.882-418.361s19.641,14.312,37.375,53.02c8.982,19.6,17.477,45.466,22.672,78.881,15.02,96.664-73.125,268.518-74.457,299.856a10.635,10.635,0,0,0,.085,2.31c3.79,23.906,362.3-97.813,362.3-97.813s16.329-11.525,34.137-32.951,31.2-72.354,49.793-82.5l1.5,32.523c-11.55,9.924-1.857,23.295,4.352,33.269,6.184,9.985,76.132-48.461,94.194-52.763s52.139,11.672-5.047,92.105",
    transform: "translate(-16239.872 8456.967)",
    fill: "#ffb7a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path436",
    d: "M8312.014-3034.138c15.021,96.664-73.125,268.518-74.457,299.856-22.672,30.836-28.673,35.8-30.1,34.918-2.591-1.6,9.021-22.928,21.95-53.777,10.854-25.862,16.635-44.122,27.279-77.769,24.371-76.938,54.512-172.147,40.174-230.166,0,0-.048-.171-11.9-46.8h0a31.754,31.754,0,0,1,4.389-5.146c8.982,19.6,17.478,45.466,22.672,78.881",
    transform: "translate(-16253.058 8452.146)",
    fill: "#f7a38f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path438",
    d: "M8237.784-3170.859s-201.248,81.362-200.857,337.182l223.309,49.511s134.137-261.8-22.452-386.693",
    transform: "translate(-16238.877 8456.967)",
    fill: "#f7f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path440",
    d: "M8847.609-2890.942a74.929,74.929,0,0,1-36.03,27.3c-5.684,2.041-3.227,11.159,2.506,9.105a85.815,85.815,0,0,0,41.677-31.643c3.521-4.974-4.656-9.692-8.152-4.767",
    transform: "translate(-16303.17 8433.811)",
    fill: "#ed867e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path442",
    d: "M8324.483-2918.343c-2.921,27.622-6.478,54.767-16.671,80.775-9.031,23.051-20.691,44.635-27.462,68.566-1.517,5.378,6.844,7.675,8.372,2.3,7.419-26.228,20.923-49.9,30.078-75.471,8.788-24.518,11.636-50.416,14.361-76.168.586-5.537-8.092-5.5-8.678,0",
    transform: "translate(-16259.148 8436.266)",
    fill: "#e3dde8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path444",
    d: "M8728.056-1339.687a17.512,17.512,0,0,0,10.841,20.435c39.281,14.825,150.147,56.124,223.822,78.282,90.835,27.316,125.275,25.373,140.59,19.9,13.774-4.913,2.37-28.184,2.37-28.184l-375.473-99.487-2.151,9.056",
    transform: "translate(-16296.438 8305.103)",
    fill: "#efedf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path446",
    d: "M8730.427-1359.965c-1.76,6.783,36.409,23.479,87.5,42.129,1.613.623,3.3,1.21,4.975,1.846,89.074,32.327,213.752,69.849,237.1,72.807,37.387,4.73,40.76,4.693,44.048-6.465,3.252-11.036,20.717-35.908-159.033-115.657a29.862,29.862,0,0,1-14.043-12.906c-4.755-8.7-10.816-22.427-10.914-36.018-.073-10.829-5.5-20.9-15.192-25.752l-80.226-40.15c-16.328-8.177-35.614.513-41.335,17.869-.586,1.784-1.234,3.557-1.93,5.292a56.678,56.678,0,0,1-5.33,10.438,30.813,30.813,0,0,1-9.985,10.132c-20.813,12.185-30.824,57.8-35.627,76.437",
    transform: "translate(-16296.67 8316.312)",
    fill: "#5e7cad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path448",
    d: "M9055.659-1313.89c-14.789,25.678-68.762-1.43-108.531-29.052-12.455-8.641-55.049-38.218-48.768-69.421,2.335-11.55,10.67-19.849,17.735-25.141l139.563,123.614",
    transform: "translate(-16310.62 8312.5)",
    fill: "#a89d98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path450",
    d: "M8822.076-1315.448a3.371,3.371,0,0,1-.134.77l5.107,1.076,5.108,1.075c10.414-49.255-32.658-122.9-46.639-142.057a56.678,56.678,0,0,1-5.33,10.438c14.238,21.425,50.172,86.7,41.886,128.7",
    transform: "translate(-16300.822 8313.924)",
    fill: "#a89d98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path452",
    d: "M9006.771-1327.418a187.952,187.952,0,0,1,25.64-16.769c2.959-1.625,5.134,3.141,2.188,4.755a182.244,182.244,0,0,0-22.341,14.385c-6.637,5.036-14.839,10.5-16.893,18.981-.782,3.263-5.671,1.369-4.888-1.87,2.1-8.69,9.582-14.226,16.291-19.482",
    transform: "translate(-16318.342 8304.75)",
    fill: "#332d3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path454",
    d: "M8936.851-1339.687a103.229,103.229,0,0,1,54.73-38.707c3.227-.966,4.082,4.2.892,5.158a97.47,97.47,0,0,0-51.369,36.617c-1.98,2.738-6.232-.33-4.253-3.068",
    transform: "translate(-16313.837 8307.583)",
    fill: "#332d3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path456",
    d: "M8898.219-1377.289a144.691,144.691,0,0,1,60.891-25.458c3.336-.574,4.229,4.6.9,5.158a138.365,138.365,0,0,0-58.457,24.346c-2.737,1.968-6.075-2.066-3.337-4.045",
    transform: "translate(-16310.574 8309.606)",
    fill: "#332d3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path458",
    d: "M8301.813-1203.366a17.893,17.893,0,0,0,11.856,20.484c40.711,13.677,155.623,51.748,231.778,71.646,93.9,24.517,129.04,21.242,144.489,15.07,13.9-5.549,1.368-28.917,1.368-28.917l-387.622-87.62-1.87,9.338",
    transform: "translate(-16260.923 8293.764)",
    fill: "#efedf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path460",
    d: "M8303.855-1224.311c-1.552,6.991,38.109,22.647,91.042,39.783,1.675.587,3.423,1.124,5.157,1.711,92.29,29.712,221.17,63.4,245.15,65.535,38.4,3.434,41.848,3.263,44.794-8.262,2.945-11.586,20.337-38.3-175.654-115.755,0,0-27.574-35.432-15.73-62.528l-98.607-44.9a34.254,34.254,0,0,0-46.8,20.667c-.294.892-.6,1.784-.917,2.664a58.738,58.738,0,0,1-5.048,10.853,31.534,31.534,0,0,1-9.826,10.743c-20.826,13.249-29.346,60.255-33.562,79.492",
    transform: "translate(-16261.118 8305.359)",
    fill: "#5e7cad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path462",
    d: "M8637.808-1189.333c-14.178,26.8-70.362,1.112-112.064-25.63-13.065-8.372-57.725-37.021-52.469-69.152,1.955-11.9,10.168-20.692,17.184-26.375l147.35,121.157",
    transform: "translate(-16275.208 8301.914)",
    fill: "#a89d98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path464",
    d: "M8398.847-1182.125a4.483,4.483,0,0,1-.109.807l5.268.9,5.256.9c8.8-50.746-38-124.445-53.02-143.487a58.738,58.738,0,0,1-5.048,10.853c15.362,21.389,54.548,86.777,47.653,130.018",
    transform: "translate(-16265.067 8302.956)",
    fill: "#a89d98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path466",
    d: "M8587.326-1201.425a192.5,192.5,0,0,1,25.58-18.1c2.97-1.772,5.377,3.019,2.42,4.779a185.045,185.045,0,0,0-22.293,15.547c-6.6,5.39-14.788,11.281-16.561,20.044-.685,3.361-5.757,1.613-5.072-1.735,1.821-8.959,9.252-14.9,15.926-20.533",
    transform: "translate(-16283.415 8294.364)",
    fill: "#332d3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path468",
    d: "M8515.389-1211.383a105.6,105.6,0,0,1,54.5-41.628c3.264-1.112,4.34,4.143,1.113,5.243a99.659,99.659,0,0,0-51.15,39.367c-1.918,2.86-6.392-.11-4.461-2.982",
    transform: "translate(-16278.713 8297.136)",
    fill: "#332d3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path470",
    d: "M8474.438-1248.4a148.047,148.047,0,0,1,61.293-28.318c3.386-.7,4.5,4.547,1.112,5.243a141.387,141.387,0,0,0-58.849,27.1c-2.714,2.1-6.294-1.894-3.557-4.021",
    transform: "translate(-16275.259 8299.104)",
    fill: "#332d3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path472",
    d: "M5872.316-2897.868c-2.261,4.29-4.522,8.666-6.857,13.114-72.7,138.708-177.268,316.563-184.993,332.33-12.5,25.458-60.781,525.071-60.781,525.071l-155.146,15.925s-29.418-464.449-17.709-555.956c6.784-53.41,68.8-258.129,119.324-419.668,2.31-7.37,4.559-14.667,6.82-21.816,32.987-105.244,59.545-187.07,59.545-187.07s280.605,118.908,301.456,146.946c7.456,10-21.242,73.076-61.66,151.125",
    transform: "translate(-16022.774 8459.057)",
    fill: "#5e7cad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path474",
    d: "M6096.969-3324.979c151.737,79.737,47.434,725.378,35.762,740.057s186.814,392.633,188.257,446.715c0,0-117.784,100.575-126.437,88.317s-260.928-396.678-280.019-463.277-103.619-543.33-102.213-619.84,284.651-191.971,284.651-191.971",
    transform: "translate(-16053.464 8469.812)",
    fill: "#5e7cad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path476",
    d: "M5850.773-2835.493a7.12,7.12,0,0,1-6.306-2.665l-42.643-54.021-8.495-82.645a7.1,7.1,0,0,1,6.343-7.785,7.076,7.076,0,0,1,7.773,6.331l8.067,78.539,40.088,50.795a7.093,7.093,0,0,1-1.161,9.961,7.075,7.075,0,0,1-3.667,1.491",
    transform: "translate(-16051.88 8441.28)",
    fill: "#3f669e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path478",
    d: "M6175.2-2995.453a7.131,7.131,0,0,1-4.107-.831c-74.249-40.345-117.283-118.187-118.677-131.8a7.046,7.046,0,0,1,6.295-7.737.045.045,0,0,0,.037-.012,7.137,7.137,0,0,1,7.786,6.306c1.209,10.841,42.153,83.183,111.331,120.778a7.092,7.092,0,0,1,2.848,9.619,7.1,7.1,0,0,1-5.513,3.679",
    transform: "translate(-16073.473 8454.051)",
    fill: "#3f669e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path480",
    d: "M5641-3033.712c-19.617,28.477-45.1,47.776-63.75,59.252,2.31-7.37,4.559-14.667,6.82-21.816,14.947-10.8,31.8-25.874,45.257-45.515a7,7,0,0,1,9.8-1.784,7.023,7.023,0,0,1,1.871,9.863",
    transform: "translate(-16033.874 8446.464)",
    fill: "#3f669e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path482",
    d: "M5326.227-3914.641s86.752,69.385,60.292,127.011.2,88.231.2,88.231l131.412,105.928,97.348-75.7,13.249-234.1s-10.792-55.757-17.685-54.669-78.343,8.177-96.3-14.911-88.476-121.1-88.476-121.1l-100.037,179.31",
    transform: "translate(-16012.952 8533.901)",
    fill: "#896060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path484",
    d: "M5154.2-4189.122s61.037,264.241,134.724,290.567,144.061-72.6,145.381-134.442-11.635-200.49-75.178-219.5-188.342,16.268-204.927,63.371",
    transform: "translate(-15998.614 8547.553)",
    fill: "#896060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path486",
    d: "M5387.307-3901.986a114.917,114.917,0,0,1-30.714,17.428,3.56,3.56,0,0,1-4.559-2.1,3.542,3.542,0,0,1,2.114-4.559c49.9-18.333,89.808-85.2,90.786-130.494a532.64,532.64,0,0,0-2.518-60.23,3.567,3.567,0,0,1,3.19-3.874,3.566,3.566,0,0,1,3.875,3.19,535.944,535.944,0,0,1,2.542,61.073c-.818,38.67-27.072,90.3-64.715,119.568",
    transform: "translate(-16015.085 8533.225)",
    fill: "#704a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path488",
    d: "M5179.513-4171.248c-14.837,17.575-17.82,30.812-50.526,27.891-52.236-4.645-86.69-42.68-64.349-92.509,27.805-62,76.07-64.3,105.684-38.462,0,0-70.741-36.373-7.773-77.6,39.477-25.825,70.228,44.232,70.228,44.232s-63.775-53.044,28.343-71.462,101.846,57.651,101.846,57.651,60.193-43.474,84.735,6.318c32.9,66.745-31.716,91.189-31.716,91.189s80.373,30.029,44.452,62.063-58.544,24.92-58.544,24.92-13.9,31.717-18.064,23.552-24.823-56.722-48.644-80.018-51.736-24.8-59.069-24.639c-37.387.819-83.159,30.946-96.6,46.872",
    transform: "translate(-15990.572 8557.911)",
    fill: "#332d3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path490",
    d: "M5421.132-4109.2c-1.088-5.781-.929-12.589,2.151-17.6,9.949-16.231,15.07-54.56,36.935-34.076,49.89,46.737-1.369,114.631-20.13,97.85-13.432-12.014-16.414-32.657-18.956-46.174",
    transform: "translate(-16020.811 8539.969)",
    fill: "#896060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path492",
    d: "M5448.893-4090.8a3.548,3.548,0,0,1-3.924.281c-14.544-8.25-18.3-22.55-10.291-39.245a3.807,3.807,0,0,1,4.729-1.967,3.328,3.328,0,0,1,2,4.3c-.037.086-.293.648-.33.734-4.448,9.265-6.771,21.975,7.382,30a3.537,3.537,0,0,1,1.344,4.828,3.516,3.516,0,0,1-.917,1.063",
    transform: "translate(-16021.647 8537.071)",
    fill: "#704a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path494",
    d: "M5230.734-3431.725c-1.8,4.779-1.724,70.423-16.7,138.1-3.959,17.893-18.8,108.385-28.7,123.785l-184.418,280.056s-74.86-15.461-98.033,6.6c-26.192,24.957,40.541,49.8,40.541,49.8s18.113-9.435,27.817-17.123,3.7-18,3.7-18-96.762,30.286-85.249,62.956-42.7,111.319,90.736,50.672c43.731-19.873,94.611-49.854,93.45-70.582s33.623-46.945,37.351-49.878c115.583-90.883,196.334-172.624,224.787-235.274,5.671-12.466,94.428-265.291,94.428-265.291l-199.72-55.818",
    transform: "translate(-15976.442 8478.708)",
    fill: "#896060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path496",
    d: "M5381.1-3812.948c4.082-2.542,59.484,108.263,103.96,94.586s59.974-230.434,63.7-230.153,127-72.1,195.809-32.486,246.617,195.235,246.617,195.235l-98.473,159.021,187.546,231.791c47.605,78.465,59.668,173.259,44.635,187.657-47.849,45.857-152.458,43.877-260.244,104.144-182.548,102.054-317.907,121.3-367.418,5.634-26-60.744-51.149-257.922-51.149-257.922s-259.865,15.962-229.322,3.838c0,0-52.3-327.11,164.337-461.345",
    transform: "translate(-16003.366 8525.476)",
    fill: "#eabb88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path498",
    d: "M5463.653-3314.936a5.928,5.928,0,0,1-.893.526,6.918,6.918,0,0,1-9.289-3.117c-.44-.892-44.879-90.687-63.249-167.454a6.914,6.914,0,0,1,5.121-8.348,6.92,6.92,0,0,1,8.348,5.121c18.015,75.251,61.746,163.629,62.186,164.509a6.93,6.93,0,0,1-2.224,8.763",
    transform: "translate(-16018.27 8483.859)",
    fill: "#d8a877"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path500",
    d: "M5892.72-3600.867a235.574,235.574,0,0,1-44.269,27.011c-15.143,6.917-14.972,6.734-24.358-3.9-6.319-7.162-11.342-16.109-16.879-23.906q-32.652-46.052-66.023-91.58c-3.263-4.461-10.792-.134-7.493,4.375q46.933,64.111,92.508,129.187c1.051,1.479,3.019,2.664,4.9,1.992a245.431,245.431,0,0,0,65.986-35.688c4.388-3.337.074-10.865-4.375-7.492",
    transform: "translate(-16046.844 8500.66)",
    fill: "#d8a877"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path502",
    d: "M5989.2-3373.98,5793.98-3257.493c-9.338,5.573-21.769,2.371-27.769-7.137L5578.9-3561.5c-6-9.521-3.3-21.755,6.037-27.316l195.223-116.5c9.326-5.573,21.768-2.371,27.769,7.138l187.3,296.885c6.014,9.509,3.313,21.743-6.025,27.316",
    transform: "translate(-16033.744 8501.739)",
    fill: "#a5b1c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path504",
    d: "M5952.644-3336.327l-242.131,144.5c-9.337,5.573-21.768,2.371-27.781-7.15l-187.3-296.873c-6-9.521-3.3-21.743,6.038-27.316l242.13-144.5c9.338-5.561,21.768-2.371,27.769,7.15l187.314,296.874c6,9.521,3.3,21.755-6.037,27.316",
    transform: "translate(-16026.788 8498.601)",
    fill: "#332d3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path506",
    d: "M5728.354-3571.708a5.35,5.35,0,0,1-1.43,1.173l-125.1,71.034a5.915,5.915,0,0,1-7.884-2.2,5.548,5.548,0,0,1,1.894-7.749l125.093-71.022a5.888,5.888,0,0,1,7.883,2.2,5.622,5.622,0,0,1-.453,6.563",
    transform: "translate(-16035.193 8491.166)",
    fill: "#a5b1c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path508",
    d: "M5996.047-3786.511s141.715,95.894,153.484,167.7-111.844,148.021-263.067,185.518c-141.127,35-98.68,21-134.5,28.808-59.191,12.906-88.06,64.862-121.939,71.584-67.783,13.444-59.008-45.539-82.145-50.526s-43.021-21.487-18.65-44.6,23.161.562,23.882-7.052-75.825-26.216-.221-45.967c30.494-7.957,134.895,6.429,148.253,4.278s185.372-133,185.372-133,124.714-146.641,109.534-176.743",
    transform: "translate(-16028.942 8508.278)",
    fill: "#896060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path510",
    d: "M6031.767-3662.544a7.091,7.091,0,0,1-4.645,7.395c-33.842,12.271-67.819,32.12-68.149,32.327a7.11,7.11,0,0,1-9.717-2.53,7.08,7.08,0,0,1,2.53-9.716c1.43-.832,35.408-20.7,70.5-33.415a7.087,7.087,0,0,1,9.093,4.241,7.1,7.1,0,0,1,.391,1.7",
    transform: "translate(-16064.796 8498.477)",
    fill: "#704a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path512",
    d: "M5648.327-1755.284a18.241,18.241,0,0,1-13.713,19.824c-42.435,10.56-164.276,47.764-242.913,63.237-104.217,20.509-125.667,9.888-146.017-6-12-9.386.978-29.455.978-29.455l400.528-57.224,1.137,9.619",
    transform: "translate(-16005.815 8339.787)",
    fill: "#896060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path514",
    d: "M5647.751-1778.54c.954,7.26-40.2,19.751-95.063,32.8-.22.025-.415.11-.635.135-1.735.464-3.544.868-5.354,1.332-1.6.379-3.276.77-4.95,1.149-95.576,22.232-214.521,48.9-238.6,49.1-39.2.391-53.337-3.923-55.342-15.84-2.09-11.99-17.5-40.5,187.706-103.081,0,0,26.155-59.179,27.573-94.061a16.937,16.937,0,0,1,16.341-15.95l123.65-5.133c-.049,2.359-1.369,24.175,3.765,42.985a58.346,58.346,0,0,0,4.253,11.477,31.624,31.624,0,0,0,9.044,11.7c20.093,15.119,24.859,63.567,27.609,83.391",
    transform: "translate(-16006.327 8353.388)",
    fill: "#efedf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path516",
    d: "M5458.7-1900.614a7.405,7.405,0,0,1,10.083-6.4c8.727,3.581,21,12.674,33.183,53.325,9.533,31.753-44.953,58.458-58.886,65.889-44.513,23.735-103.63,45.209-115.816,16.842L5431-1843.122c17.221-16.3,25.825-35.688,27.707-57.493",
    transform: "translate(-16013.038 8351.677)",
    fill: "#e3dde8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path518",
    d: "M5637.921-1869.719c-16.487,19.384-57.2,83.477-58.409,127.891-.22.025-.415.11-.635.135-1.735.464-3.545.868-5.354,1.332-1.6.379-3.276.77-4.95,1.149-.342-51.956,48.913-124.555,65.1-141.983a58.316,58.316,0,0,0,4.253,11.477",
    transform: "translate(-16033.149 8349.479)",
    fill: "#eabb88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path520",
    d: "M5391.941-1771.622a195.814,195.814,0,0,0-24.481-20.46c-2.872-2.041-5.7,2.628-2.848,4.657a188.733,188.733,0,0,1,21.364,17.6c6.246,6.013,14.067,12.65,15.155,21.694.428,3.471,5.708,2.1,5.292-1.344-1.112-9.24-8.176-15.876-14.483-22.146",
    transform: "translate(-16016.053 8342.095)",
    fill: "#a89d98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path522",
    d: "M5464.2-1780.977c-11.807-21.132-27.854-33.831-50.049-43.413-3.227-1.393-4.743,3.85-1.565,5.231,20.851,9,35.787,21.046,46.847,40.846,1.724,3.055,6.49.415,4.767-2.664",
    transform: "translate(-16020.003 8344.765)",
    fill: "#a89d98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path524",
    d: "M5507.936-1815.543a150.535,150.535,0,0,0-59.889-33.757c-3.373-.99-4.925,4.241-1.552,5.231a144.142,144.142,0,0,1,57.5,32.3c2.591,2.359,6.539-1.405,3.936-3.776",
    transform: "translate(-16022.818 8346.831)",
    fill: "#a89d98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path526",
    d: "M6440.572-1923.281a16.757,16.757,0,0,1-2.236,22.061c-29.492,27.341-111.147,111.44-167.626,158.813-74.859,62.809-96.859,63.775-120.3,60.01-13.836-2.224-12.3-24.163-12.3-24.163l297.276-223.969,5.183,7.248",
    transform: "translate(-16080.614 8353.591)",
    fill: "#896060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path528",
    d: "M6435.349-1939.733c4,5.414-23.613,33.757-62.027,68.639-.158.11-.281.281-.44.391-1.2,1.149-2.48,2.273-3.728,3.459-1.124,1.014-2.3,2.065-3.471,3.117-67.136,60.352-151.112,134.662-170.437,145.516-31.41,17.71-44.72,20.521-51.626,11.806-7-8.727-32.082-24.86,105.452-166.4,0,0-5.194-59.3-19.555-88.023a15.587,15.587,0,0,1,6.086-20.105l97.336-59.045c1.015,1.919,9.644,20.081,22.135,32.951a53.345,53.345,0,0,0,8.519,7.358,28.819,28.819,0,0,0,12.479,5.4c22.9,3.263,48.252,40.186,59.277,54.938",
    transform: "translate(-16080.548 8362.747)",
    fill: "#efedf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path530",
    d: "M6226.031-1945.436a6.82,6.82,0,0,1,5.28-9.643c8.629-.99,22.538.892,50.416,28.221,21.781,21.352-10.253,67.062-18.186,79.235-25.324,38.891-63.42,82.45-85.836,65.009l51.541-104.205c6.637-20.777,4.95-40.223-3.215-58.617",
    transform: "translate(-16083.918 8355.653)",
    fill: "#e3dde8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path532",
    d: "M6382.9-1997.077c-4.681,22.941-9.007,92.655,9.729,128.979-.159.11-.281.281-.44.391-1.2,1.149-2.48,2.273-3.728,3.459-1.125,1.014-2.3,2.066-3.471,3.117-23.357-41.714-15.914-122.074-10.609-143.3a53.309,53.309,0,0,0,8.519,7.358",
    transform: "translate(-16099.854 8359.751)",
    fill: "#eabb88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path534",
    d: "M6224.1-1806.307a181.788,181.788,0,0,0-28.807-5.61c-3.215-.367-3.422,4.644-.232,5.023a172.347,172.347,0,0,1,25.031,4.693c7.7,2.066,16.951,3.936,21.853,10.743,1.87,2.6,5.524-.843,3.667-3.434-5.011-6.954-13.652-9.166-21.511-11.415",
    transform: "translate(-16085.174 8343.707)",
    fill: "#a89d98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path536",
    d: "M6278.149-1845.984c-18.9-11.77-37.46-14.874-59.606-12.748-3.215.318-2.115,5.219,1.063,4.913,20.8-2,38.181,1.063,55.891,12.1,2.738,1.711,5.4-2.542,2.652-4.266",
    transform: "translate(-16087.161 8347.659)",
    fill: "#a89d98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path538",
    d: "M6298.048-1893.516a138.557,138.557,0,0,0-63.25-.6c-3.153.709-2.077,5.61,1.076,4.913a132.533,132.533,0,0,1,60.682.477c3.129.758,4.645-4.033,1.491-4.791",
    transform: "translate(-16088.52 8350.837)",
    fill: "#a89d98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path540",
    d: "M3754.925-1484.455l10.584,407.018s-61.22,100.587-96.921,421.306c0,0-54.889,112.027-33.012,125.41S3924.1-481.636,3924.1-481.636s39.453-7.211,25.923-23.65-110.842-60.841-151.223-79.737c-18.1-8.47-28.624-63-23.32-98.876,1.7-11.452,153.179-400.651,153.179-400.651l65.4-445.1s-245.235-9.35-239.136,45.2",
    transform: "translate(-15871.615 8320.23)",
    fill: "#ffb0a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path542",
    d: "M3628.1-467.492l-.733,12.723s-1.711,16.622,4.327,23.8c8.115,9.607,159.045,59.008,295.859,52.665,8.189-.379,20.252-8.6,22.122-16.585.795-3.4,4.865-17.453,2.322-20.252-7.6-8.4-323.9-52.347-323.9-52.347",
    transform: "translate(-15871.342 8231.654)",
    fill: "#896060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path544",
    d: "M3955.075-415.927a30.72,30.72,0,0,1-2.053,7.553,4.459,4.459,0,0,1-2.3,3.373c-16.182,10.817-112.651-1.894-196.066-18.48q-6.509-1.283-12.931-2.628c-61.733-12.821-113.274-27.243-114.3-34.845-.4-2.579-.171-6.979.685-12.528,0-.061-.061-.122,0-.171a181.091,181.091,0,0,1,8.458-33.586c.465-1.381.978-2.75,1.491-4.119.171-.464.343-.978.513-1.43.635-1.662,1.259-3.263,1.943-4.864.354-.807.7-1.662,1.088-2.457.465-1.088.978-2.127,1.43-3.153a101.191,101.191,0,0,1,9.044-15.9,6.632,6.632,0,0,1,10.072-.684c4.057,3.887,9.948,9.607,16.3,15.9a141.533,141.533,0,0,0,69.568,37.644l73.87,15.791s-3.605-3.667-8.592-9.093c-3.141-3.324-6.857-7.443-10.462-11.733-3.667-4.119-7.272-8.519-10.242-12.638a63.456,63.456,0,0,1-7.04-11.159c-1.149-2.64-1.32-4.632-.281-5.671,6.685-6.233,10.071-7.382,18.479,1.43a26.359,26.359,0,0,1,2.115,2.237c2.86,3.031,6,6.466,9.5,10.01a94.294,94.294,0,0,0,17.906,14.593,56.4,56.4,0,0,0,5.549,2.86c2.921,1.32,7.9,3.092,14.128,5.207,7.785,2.628,17.514,5.781,27.756,9.264,6.746,2.347,13.726,4.8,20.533,7.382,17.856,6.747,34.5,14.19,42.288,21.4a6.118,6.118,0,0,1,.794.794,37.069,37.069,0,0,1,8.409,11.843,28.537,28.537,0,0,1,1.943,6.355,34.556,34.556,0,0,1,.4,11.5",
    transform: "translate(-15871.35 8237.851)",
    fill: "#efedf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path546",
    d: "M3755.507-421.5q-6.508-1.283-12.931-2.628c-16.3-37.253-65.449-63.163-105.158-81.13.464-1.381.978-2.75,1.491-4.119.171-.464.343-.978.513-1.43.635-1.662,1.259-3.263,1.943-4.864.354-.807.7-1.662,1.088-2.457,2.518.856,4.412,1.54,4.987,1.772,45.82,19.959,88.109,44.109,107.615,92.509a6.292,6.292,0,0,1,.452,2.347",
    transform: "translate(-15872.198 8235.875)",
    fill: "#5e7cad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path548",
    d: "M3829.76-504.893a172.462,172.462,0,0,1-22.794,3.178,62.506,62.506,0,0,1-7.015-11.183,161.454,161.454,0,0,0,20.3-1.98c2.885,2.994,6.013,6.465,9.509,9.985",
    transform: "translate(-15885.744 8235.604)",
    fill: "#5e7cad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path550",
    d: "M3868.9-480.011a179.513,179.513,0,0,1-39.648,4.9c-3.129-3.349-6.82-7.455-10.45-11.721a162.949,162.949,0,0,0,30.421-1.234,57.746,57.746,0,0,0,5.537,2.872c2.934,1.32,7.92,3.068,14.141,5.182",
    transform: "translate(-15887.315 8233.369)",
    fill: "#5e7cad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path552",
    d: "M3921.5-461.776a3.019,3.019,0,0,1-1.051.4,418.4,418.4,0,0,1-43.523,7.908c-7.345.953-8.959-10.609-1.687-11.525,8.617-1.112,17.221-2.493,25.74-4.156,6.759,2.359,13.725,4.815,20.521,7.37",
    transform: "translate(-15891.627 8231.792)",
    fill: "#5e7cad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path554",
    d: "M3995.914-1369.322l169.068,335.752s-8.495,179.884,99.658,444.344c0,0-12.564,124.237,12.222,128.368s276-99.793,276-99.793,34.014-21.523,15.9-31.631-90.151,8.531-133.917,6.245c-19.628-1.014-73.528-33.941-80.836-69.091-2.347-11.232-50.636-442.364-50.636-442.364l-91.262-436.131s-240.432,116.17-216.2,164.3",
    transform: "translate(-15901.934 8320.511)",
    fill: "#ffb0a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path556",
    d: "M4285.363-386.7l4.926,12.87s5.72,17.209,14.446,21.169c11.721,5.329,172.673-22.9,296.1-98.717,7.382-4.534,14.9-18.749,13.1-27.536-.758-3.74-3.178-19.616-6.746-21.071-10.719-4.388-321.831,113.286-321.831,113.286",
    transform: "translate(-15926.201 8234.372)",
    fill: "#896060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path558",
    d: "M4612.453-485.349c-9.96,18.48-100.807,53.887-183.66,79.92-3.887,1.2-7.724,2.408-11.55,3.544C4351.793-381.853,4294.057-368.7,4289.6-375.9c-1.491-2.347-3.2-6.759-4.914-12.65,0-.061-.061-.11-.061-.171a220.258,220.258,0,0,1-6.979-37.815c-.232-2-.4-3.948-.513-5.952-.171-1.833-.294-3.667-.343-5.488-.122-2.408-.171-4.754-.171-7.1a127.038,127.038,0,0,1,1.308-20.191,7.013,7.013,0,0,1,9.044-5.781c5.438,1.772,13.383,4.4,22.024,7.321a134.015,134.015,0,0,0,80.727,1.6l75.117-22.085s-4.975-1.772-11.954-4.522c-4.351-1.711-9.606-3.826-14.812-6.233-5.207-2.176-10.474-4.693-15.045-7.15a61.868,61.868,0,0,1-11.391-7.443c-2.175-1.992-3.263-3.826-2.75-5.378,3.435-9.545,6.013-12.405,17.686-8.066.965.354,1.943.745,2.909,1.149,4.009,1.491,8.421,3.324,13.224,4.974a87.324,87.324,0,0,0,22.879,5.268,62.428,62.428,0,0,0,6.417,0c3.251-.171,8.629-1.027,15.265-2.114,8.36-1.381,18.712-3.2,29.761-4.974,7.26-1.149,14.752-2.237,22.134-3.214,19.458-2.457,38.108-3.593,48.46-.452a7.441,7.441,0,0,1,1.088.342,35.836,35.836,0,0,1,12.931,7.382,30.2,30.2,0,0,1,4.631,5.268,38.34,38.34,0,0,1,5.378,11.1,39.393,39.393,0,0,1,1.491,8.409,5.755,5.755,0,0,1-.684,4.522",
    transform: "translate(-15925.472 8236.445)",
    fill: "#efedf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path560",
    d: "M4428.809-397.532c-3.887,1.2-7.724,2.408-11.55,3.544a351.6,351.6,0,0,0-139.6-24.652c-.232-2-.4-3.948-.513-5.952-.171-1.833-.294-3.667-.343-5.488a360.771,360.771,0,0,1,148.23,26.937,6.017,6.017,0,0,1,3.776,5.61",
    transform: "translate(-15925.487 8228.548)",
    fill: "#5e7cad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path562",
    d: "M4454.955-516.571a183.952,183.952,0,0,1-19.641,14.715c-4.754-2.567-8.861-5.1-11.379-7.419a170.464,170.464,0,0,0,17.844-12.271c3.985,1.479,8.409,3.3,13.175,4.974",
    transform: "translate(-15937.75 8236.159)",
    fill: "#5e7cad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path564",
    d: "M4501.967-512.679a191.938,191.938,0,0,1-34.417,24.97c-4.351-1.7-9.57-3.862-14.8-6.209a169.183,169.183,0,0,0,27.524-16.683,52.676,52.676,0,0,0,6.368.012c3.3-.2,8.665-1.014,15.327-2.09",
    transform: "translate(-15940.151 8235.42)",
    fill: "#5e7cad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path566",
    d: "M4558.8-521.625a3.719,3.719,0,0,1-.794.929,452.718,452.718,0,0,1-36.679,29.907c-6.355,4.657-12.919-5.879-6.625-10.474q11.2-8.213,21.926-17.172c7.26-1.124,14.776-2.249,22.171-3.19",
    transform: "translate(-15945.103 8236.166)",
    fill: "#5e7cad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path568",
    d: "M3757.44-1753.324c-5.072,17.465-73.039,573.372,5.39,589.884,35.285,7.419,126.864,16.915,184.724,6.93a42.146,42.146,0,0,0,34.869-43.266l-7.541-187.9c-.232,7.834,77.036,227.855,99.7,222.4,67.979-16.39,190.126-21.327,195.87-58.213,2.249-14.4-100.269-535.252-107.872-541.742s-405.136,11.9-405.136,11.9",
    transform: "translate(-15879.521 8339.93)",
    fill: "#d38888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path570",
    d: "M3982.926-1373.738a8.989,8.989,0,0,1-8.458-5.94c-22.66-62.833-49.292-131.912-55.733-141.776-.293-.183-.635-.391-1.026-.611-61.856-36.776-95.918-99.365-95.918-176.23a9,9,0,0,1,9-9,9,9,0,0,1,9,9c0,70.265,30.934,127.354,87.119,160.757,1.234.745,2.151,1.3,2.713,1.662,2.75,1.846,10.071,6.722,61.771,150.087a9,9,0,0,1-5.4,11.525,9.236,9.236,0,0,1-3.056.526",
    transform: "translate(-15887.564 8334.985)",
    fill: "#c97777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path572",
    d: "M4149.031-2756.646s-7.272,174.971-65.425,196.787-192.656,61.794-156.308,0,30.176-184.809,45.319-243.06,176.413,46.272,176.413,46.272",
    transform: "translate(-15895.847 8427.772)",
    fill: "#ffb0a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path574",
    d: "M4186.738-2995.568s99.329,232.048,30.824,271.916-226.046,22.733-232.9-18.357,71.927-394.075,202.079-253.559",
    transform: "translate(-15901.104 8445.096)",
    fill: "#ffb0a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path576",
    d: "M4146.883-2683.533c-18.908,2.554-38.365-.978-54.73-11-10.3-6.306-18.969-21.547-30.873-23.454-6.807-1.075-9.729,9.325-2.872,10.413,7.382,1.185,15.045,13.151,21.071,17.563a93.285,93.285,0,0,0,20.4,11.342c16.121,6.5,32.767,7.859,49.878,5.549,6.856-.929,3.935-11.33-2.872-10.413",
    transform: "translate(-15906.96 8419.229)",
    fill: "#ed867e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path578",
    d: "M3729.844-2801.77c-10.67,54.669,63.322,129.126,137.413,143.487,21,4.058,39.4,5.622,56.075,1.418,113.1-28.575,113.1-28.575,154.206-76.07s-28.832-116.989,14.128-181.913,152.556-76.644,90.907-149.561c-50.4-59.62-139.587-63.31-155.44-63.384-7.541-.037-143.755,1.1-190.223,86.483-31.191,57.3,7.773,97.886-30.849,159.693-31.191,49.9-69.116,43.462-76.217,79.847",
    transform: "translate(-15879.815 8453.377)",
    fill: "#896060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path580",
    d: "M4138.021-2950.386c-19.556,22.012-44.159,38.426-73.088,45.294-13.774,3.276-27.1,4.095-41.152,3.728-6.184-.171-12.967-1.674-18.687,1.76-11.635,6.954-16,29.3-22,40.541-14.862,27.854-34.136,52.457-64.618,63.554-6.869,2.493-3.9,13.554,3.043,11.036,21.792-7.932,38.695-21.095,52.86-39.44,12.723-16.463,22.207-53.19,38.964-62.919,11.085-6.441,27.524-2.493,40.467-4.412a148.81,148.81,0,0,0,34.625-9.46c22.574-9.216,41.555-23.442,57.676-41.592,4.876-5.488-3.19-13.6-8.091-8.091",
    transform: "translate(-15895.298 8438.744)",
    fill: "#704a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path582",
    d: "M4027.667-2893.592c.171-.66.317-1.332.464-2.029.122-.574.269-1.124.367-1.711,1.455-9.313-7.443-18.871-10.829-27.61-6.49-16.744-28.1-6.026-24.371,8.213,3.739,14.263,7,24.212,15.082,36.348a5.587,5.587,0,0,0,5.573,1.467c9.167-3.141,11.978-7.737,13.713-14.679",
    transform: "translate(-15901.823 8437.181)",
    fill: "#a89d98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path584",
    d: "M3903.825-2579.781s-179.138,228.112-190.053,292.339,121.267,306.712,121.267,306.712l68.786-599.051",
    transform: "translate(-15878.508 8407.703)",
    fill: "#ffb0a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path586",
    d: "M3904.976-2579.781s-198.425,205.281-176.327,235.543,145.87,111.783,145.87,111.783l30.457-164.044v-183.282",
    transform: "translate(-15879.658 8407.703)",
    fill: "#4f939d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path588",
    d: "M4348.014-2406.532c9.937-4.925,173.406-63.188,183.637-73.8s258.313-207.53,267-209.425c4.339-.941,73.467-32.449,133.465-41.433,60.206-9.02,111.209,4.424,89.819-22.745-16.3-20.716-118.077-42.484-118.077-42.484s28.355-48.069-5.12-34.479-75.532,26.632-92.387,29.761-19.983,32.388-38.255,41.885-229.7,142.448-245.969,145.98-253.326,81.8-253.326,81.8l79.211,124.933",
    transform: "translate(-15924.82 8428.834)",
    fill: "#ffb0a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path590",
    d: "M4949.932-2754.95c2.2,3.422,4.4,6.771,6.783,10.059,5.989,8.189,15.95,23.65,11.464,30.14-6.246,9.057-17.416,22.061-16.426,21.12s-36.446-67.014-23.222-73.137c9.265-4.29,17.368,5.537,21.4,11.818",
    transform: "translate(-15979.569 8423.375)",
    fill: "#896060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path592",
    d: "M4889.059-2732.658s25.214,56.747,29.271,55.757c5.732-1.418,12.8-1.809,21.523-8.4s-34.381-60.792-41.164-61.379c-4.925-.416-14.7,2.09-9.631,14.019",
    transform: "translate(-15976.397 8421.616)",
    fill: "#896060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path594",
    d: "M4908.586-2681.674c-7.615,5.366-18.285,2.457-23.161-5.488-11.256-18.345-31.374-53.4-24.872-59.912,8.9-8.9,49.743,52,51.21,59.753.416,2.224-.978,4.094-3.177,5.646",
    transform: "translate(-15974.034 8421.72)",
    fill: "#896060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path596",
    d: "M3922.547-2614.047s51.87,61.623,188.929,4.718l295.138,36.08c46.762,82,9.7,228.173-21.755,282.952-9.937-6.1-150.856-14.165-150.856-14.165s70.375,67.258,16.354,124.4c-126.4,133.733,24.419,274.935-25.984,330.5-78.49,86.507-266.05,65.486-309.609,57.578-27.878-5.06-64.337-16.023-116.867-9.448-36.128,4.534-48.485,13.505-61.293,5.7-32.168-19.592-10.535-110.353-4.082-136.532,54.865-222.515,165.083-625.72,171.83-650.359q9.093-15.711,18.2-31.411",
    transform: "translate(-15879.031 8410.56)",
    fill: "#4f939d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path598",
    d: "M4278.505-2268.642a5.25,5.25,0,0,1-1.369-.171c-100.147-24.566-138.744-74.114-140.333-76.217a5.712,5.712,0,0,1,1.087-8.018,5.738,5.738,0,0,1,8.03,1.075h0c.367.489,38.084,48.522,133.942,72.037a5.718,5.718,0,0,1,4.2,6.93,5.724,5.724,0,0,1-5.562,4.363",
    transform: "translate(-15913.722 8388.903)",
    fill: "#e3dde8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path600",
    d: "M3854.077-2406.087a508.593,508.593,0,0,0-31.129,131.533c-.709,6.942,10.156,6.894,10.865,0a498.479,498.479,0,0,1,30.726-128.649c2.506-6.527-7.993-9.362-10.462-2.884",
    transform: "translate(-15887.658 8393.531)",
    fill: "#e3dde8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path602",
    d: "M7170.022-3812.319l536.8-163.6,77.133,238.391S7446.522-3566.925,7390-3580.9s-201.811-66.537-201.811-66.537l-18.162-164.887",
    transform: "translate(-16166.623 8524.064)",
    fill: "#896060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path604",
    d: "M6982.508-2199.86s-6.869,24.737,28.575,38.145c27.06,10.23,93.584,9.741,134.369-7.455,32.12-13.542,53.02-40.467,113.164-63.188,63.028-23.809,74.31-43.706,69.519-69.079-3.96-20.961-15.241-29.895-18.908-29.8-6.355.183-326.719,131.375-326.719,131.375",
    transform: "translate(-16150.95 8386.988)",
    fill: "#c9b8b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path606",
    d: "M7191.849-2393.457l17.013,65.6s-12.112,36.7,40.492,25.63,62.784-32.988,62.784-32.988l-7.712-66.256-112.577,8.018",
    transform: "translate(-16168.442 8392.842)",
    fill: "#b5a29e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path608",
    d: "M6981.658-2190.421c-2.616-9.4,3.007-19.018,13.1-24.505,14.5-7.9,43.645-24.811,81.583-52.09,31.582-22.708,55.793-39.636,66.439-58.348,18.749-32.95,59.606-24.713,73.614-7.859,11.843,14.251,27.6,11.5,27.6,11.5s32.669-5.023,39.4-24.151c4.95-14.067,8.8-16.817,21.817,6.2,10.206,18.052,19.873,20.276,15.094,39.331s-150.429,111.905-257.739,126.425c-60.364,8.152-77.475-4.155-80.91-16.5",
    transform: "translate(-16150.87 8389.111)",
    fill: "#332d3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path610",
    d: "M7237.369-2308.859h-.048c-53.52-.635-80.543-11.073-81.667-11.526-1.675-.66-2.347-2.261-1.5-3.568a3.891,3.891,0,0,1,4.56-1.174c.269.1,26.937,10.34,78.722,10.951,1.87.024,3.373,1.222,3.336,2.7-.024,1.455-1.541,2.616-3.4,2.616",
    transform: "translate(-16165.27 8386.503)",
    fill: "#c9b8b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path612",
    d: "M7126.582-2282.4c-1.748,0-3.239-1.063-3.373-2.457-.146-1.454,1.246-2.738,3.129-2.848,23.442-1.418,78.392-4.62,82.608-3.7,1.81.391,2.86,1.858,2.359,3.276-.489,1.368-2.249,2.176-4.046,1.87-4.485-.44-51.613,2.115-80.409,3.85a1.921,1.921,0,0,1-.269.012",
    transform: "translate(-16162.721 8383.682)",
    fill: "#c9b8b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path614",
    d: "M7173.985-2271a4.386,4.386,0,0,1-1.527-.281c-6.808-2.677-27.646-23.711-31.754-27.9a2.294,2.294,0,0,1,.624-3.728,4.019,4.019,0,0,1,4.754.5c9.827,10.01,25.446,24.823,29.419,26.375,1.674.66,2.358,2.249,1.516,3.557a3.61,3.61,0,0,1-3.031,1.479",
    transform: "translate(-16164.12 8384.673)",
    fill: "#c9b8b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path616",
    d: "M7108.256-2245.287a3.728,3.728,0,0,1-2.811-1.161l-13.249-15.216a2.323,2.323,0,0,1,.892-3.691,4.035,4.035,0,0,1,4.718.7l13.261,15.216a2.325,2.325,0,0,1-.9,3.691,3.963,3.963,0,0,1-1.906.465",
    transform: "translate(-16160.088 8381.535)",
    fill: "#c9b8b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path618",
    d: "M7081.449-2251.68a3.866,3.866,0,0,1-2.554-.929,2.332,2.332,0,0,1,.391-3.813c3.435-2.4,43.083-9.79,47.055-9.374,1.858.183,3.178,1.5,2.946,2.97-.231,1.43-1.918,2.4-3.69,2.31h0c-4.082,0-38.243,6.417-42.02,8.2a3.777,3.777,0,0,1-2.126.635",
    transform: "translate(-16158.959 8381.535)",
    fill: "#c9b8b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path620",
    d: "M7145.343-3739.311c10.914,31.251,16.194,1158.613,25.52,1241.233a18.36,18.36,0,0,0,11.917,15.216c28.8,10.646,107.493,35,134.76-4.192,45.209-64.972,130.617-919.036,130.837-1105.043l-303.034-147.214",
    transform: "translate(-16164.566 8504.344)",
    fill: "#896060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path622",
    d: "M7326.747-3045.354h0Zm-7.272,65.987a10.872,10.872,0,0,1-8.2-3.752,10.845,10.845,0,0,1,1.088-15.314l33.023-28.661c-12.3,2.994-20.655,3.826-24.994,2.506a10.853,10.853,0,0,1-7.2-13.554,10.827,10.827,0,0,1,12.894-7.382h.33c7.456,0,37.717-9.2,62.186-18.113a10.887,10.887,0,0,1,13.078,4.706,10.846,10.846,0,0,1-2.249,13.7l-72.843,63.2a10.8,10.8,0,0,1-7.113,2.665",
    transform: "translate(-16178.174 8448.084)",
    fill: "#7c4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path624",
    d: "M7559.944-2279.314s-7.725,20.839,8.14,36.067c5,4.791,23.76,4.705,45.8,17.8,57.737,34.295,128.405,67.6,204.01,47.874,0,0,39.918-12.687,53.984-32.608s-32.779-32.168-32.779-32.168l-279.15-36.959",
    transform: "translate(-16198.964 8382.66)",
    fill: "#c9b8b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path626",
    d: "M7557.822-2387.767l4.583,65.73c51.1,53.41,92.7,37.009,137.18-12.209,0,0-20.863-1.271-26.387-21.071s4.314-58.092-3.8-77.9l-111.575,45.454",
    transform: "translate(-16198.944 8395.488)",
    fill: "#b5a29e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path628",
    d: "M7569.839-2329.127c-2.664-2.518-8.909-.1-9.02,3.337-.367,12.247-.917,32.474-.709,40.773.464,19.384,26.021,26.473,37.717,32.633,52.359,27.561,78.539,41.347,119.654,50.758,32.915,7.529,77.108,13.261,120.46,2.995,44.268-10.487,41.127-52.261,4.229-70.045-39.99-19.262-113.42-54.009-122.11-63.432s-23.588-18.443-37.155-14.813-63.323,8.849-57.15,34.442c1.161,4.84-11.452,3.056-20.362,2.053-27.964-3.178-26.326-9.937-35.554-18.7",
    transform: "translate(-16199.132 8388.364)",
    fill: "#332d3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path630",
    d: "M7755.113-2305.286a5.213,5.213,0,0,1-2.041.061c-11.013-1.98-60.817,7.333-79.076,11.085-2.078.428-3.96-.416-4.217-1.882s1.173-2.945,3.275-3.434c6.918-1.417,68.053-13.823,82.865-11.159,1.931.342,2.86,1.845,2.078,3.324a4.368,4.368,0,0,1-2.885,2",
    transform: "translate(-16208.272 8385.301)",
    fill: "#c9b8b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path632",
    d: "M7690.875-2275.092a5.834,5.834,0,0,1-1.21.134c-2.064,0-3.47-1.234-3.141-2.762,2.812-13.114,33.66-43.339,34.98-44.623a5.018,5.018,0,0,1,5.317-.941c1.6.782,1.809,2.481.464,3.8-8.568,8.348-31.24,32.144-33.292,41.763a4,4,0,0,1-3.117,2.628",
    transform: "translate(-16209.667 8386.358)",
    fill: "#c9b8b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path634",
    d: "M7744.687-2255.4a4.409,4.409,0,0,1-.55.11c-2.09.257-3.813-.746-3.85-2.237-.562-22.146,33.146-40.5,34.576-41.286,1.809-.941,4.107-.794,5.17.4,1.051,1.173.44,2.921-1.356,3.887-.306.171-31.313,17.1-30.837,36.018.037,1.369-1.344,2.689-3.153,3.1",
    transform: "translate(-16214.151 8384.337)",
    fill: "#c9b8b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path636",
    d: "M7796.7-2279.815a5.655,5.655,0,0,1-1.442.146c-24.579-1.161-69.775,6.93-72.831,7.651-2.053.477-4-.305-4.339-1.748s1.052-3.019,3.1-3.508c3.166-.745,50.086-9.13,75.715-7.932,2.029.1,3.313,1.418,2.86,2.946a4.105,4.105,0,0,1-3.067,2.445",
    transform: "translate(-16212.296 8383.161)",
    fill: "#c9b8b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path638",
    d: "M7641.156-2304.917c-1.98.465-3.875-.244-4.3-1.613-.452-1.43.831-3.043,2.872-3.593.551-.147,55.366-15.278,71.035-26.437a4.786,4.786,0,0,1,5.316-.244c1.332,1.014,1.1,2.762-.514,3.911-17.062,12.161-71.89,27.279-74.212,27.915-.061.024-.135.037-.2.061",
    transform: "translate(-16205.523 8387.51)",
    fill: "#c9b8b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path640",
    d: "M7447.389-3590.848c-5.1,24.53,82.205,948.992,92.729,1091.9,1.894,25.825,26.656,28.123,52.542,29.1,48.632,1.809,87.986,14.251,92.142-50.929,0,0,104.78-1096.732,121.365-1149.519,12.369-39.367-358.777,79.443-358.777,79.443",
    transform: "translate(-16189.723 8499.258)",
    fill: "#896060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path642",
    d: "M7622.985-2992.753a10.532,10.532,0,0,1-2.86-.391l-92.765-25.214a10.862,10.862,0,0,1-7.859-12.247,10.974,10.974,0,0,1,11.4-9.068c26.424,1.662,58.36,2.713,63.909,1.405,5.476-2.359,11.476.33,13.848,5.842a11.06,11.06,0,0,1-3.373,12.736l20.533,5.6a10.842,10.842,0,0,1,7.626,13.322,10.868,10.868,0,0,1-10.462,8.018",
    transform: "translate(-16195.738 8446.034)",
    fill: "#7c4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path644",
    d: "M7470.691-3553.474a171.6,171.6,0,0,1-63.286-78.661c-2.567-6.417-13.065-3.617-10.475,2.885A184.42,184.42,0,0,0,7465.2-3544.1c5.793,3.936,11.232-5.463,5.488-9.374",
    transform: "translate(-16185.501 8495.714)",
    fill: "#7c4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path646",
    d: "M7404.668-4716.015s-1.871,102.641-28,111.966-17.722,16.793-17.722,16.793,133.428,152.09,136.227,151.149,145.552-147.41,141.825-148.351-57.859-39.184-59.717-53.179-10.267-65.314-10.267-65.314l-162.345-13.065",
    transform: "translate(-16182.262 8585.747)",
    fill: "#ffb0a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path648",
    d: "M7622.248-4820.235c-3.813,91.25-47.348,167.246-128.6,167.246s-128.943-83.819-136.826-174.849c-16.451-190.041,50.953-168.921,132.169-171.035,106.808-2.8,141.433-17.453,133.257,178.638",
    transform: "translate(-16181.984 8609.437)",
    fill: "#ffb0a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path650",
    d: "M7497.036-4623.762c-40.614,0-75.728-20.3-101.541-58.714a2.99,2.99,0,0,1,1.1-4.314,3.572,3.572,0,0,1,4.669,1c24.5,36.471,57.626,55.745,95.771,55.745,34.564,0,63.261-13.823,85.3-41.1a3.592,3.592,0,0,1,4.753-.648,2.99,2.99,0,0,1,.685,4.4c-23.051,28.538-54.425,43.632-90.736,43.632",
    transform: "translate(-16185.372 8583.351)",
    fill: "#ed867e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path652",
    d: "M7620.681-4985.734c-26.277-72.269-46.847-130.495-75.667-126.363-7.847-4.693-36.19,17.918-83.416,40.736-42.068,20.337-44.55,18.04-57.456,26.534-17.124,11.281-42.3,34.772-55.17,87.326-.293,1.186-.965,3.4-1.577,5.891-5.365,21.694-9.752,63.029,16.158,127.183q3.721-17.838,7.443-35.664c-3.447-12.051-9.021-38.548,2.016-68.3,15.583-42.031,56.967-70.716,100.954-78.16,46.773-7.92,105.623,6.637,124.09,40,13.811,24.945,15.583,79.37,13.676,96.468,0,0-1.405,12.943,1.235,13.737,2.041.6,5.06-3.751,5.06-3.751a107.654,107.654,0,0,0,11.635-21.389c18.137-44.94-.954-88.415-8.983-104.254",
    transform: "translate(-16181.065 8618.811)",
    fill: "#332d3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path654",
    d: "M7622.546-4818.962c-10.694,19.127-8.324,39.892,5.316,46.395s33.342-3.715,44.036-22.83,8.311-39.893-5.317-46.4-33.354,3.715-44.036,22.831",
    transform: "translate(-16203.78 8596.394)",
    fill: "#ffb0a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path656",
    d: "M7644.1-4786.634a3.326,3.326,0,0,1-2.31-1.821c-8.714-18.883,14.508-36.141,15.51-36.862a3.575,3.575,0,0,1,4.767.514,2.976,2.976,0,0,1-.55,4.4c-.2.146-20.154,15.021-13.481,29.492a3.05,3.05,0,0,1-1.784,4.119,3.62,3.62,0,0,1-2.151.159",
    transform: "translate(-16205.779 8594.913)",
    fill: "#ed867e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path658",
    d: "M7373.913-4805.335c11.269,18.834,9.509,39.661-3.923,46.505s-33.44-2.86-44.7-21.694-9.508-39.661,3.924-46.518,33.439,2.872,44.7,21.707",
    transform: "translate(-16178.945 8595.184)",
    fill: "#ffb0a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path660",
    d: "M7362.142-4774.782a3.867,3.867,0,0,1-.929.11,3.271,3.271,0,0,1-3.374-3.165c.146-20.252-18.272-27.109-18.455-27.17a3.075,3.075,0,0,1-1.932-4.07,3.491,3.491,0,0,1,4.388-1.785c.232.085,22.978,8.543,22.781,33.073a3.192,3.192,0,0,1-2.48,3.007",
    transform: "translate(-16180.558 8593.671)",
    fill: "#ed867e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path662",
    d: "M6664.708-5435.732c-38.524-67.1-58.911-140.517-16.61-176.266,8.189-6.918,17.124,42.081,17.478,44.257-.073-1.516-.929-26.73-.464-53.386.514-27.463,20.973-18.321,24.163,14.434,3.153,32.707,79.418,134.063,83.306,137.816,3.911,3.8,0,0-1.1-14.715-1.136-14.764-15.265-66.463-2.86-71.792,32.609-13.982,48.253,118.651,58.287,152.213,1.577,5.415,2.469,8.507,2.469,8.507-16.341,69.9-65.791,100.269-76.693,75.862,0,0-3.948-5.562-10.462-15.156-15.351-22.709-50.465-54.6-77.512-101.772",
    transform: "translate(-16121.162 8662.536)",
    fill: "#ffb0a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path664",
    d: "M6747.479-5297.527c-2.266-3.693-3.1-11.833,1-11.772,23.4.4,67.484-35.34,81.417-72.582,1.455,5.4,58.025,172.52,58.025,172.52-57.653,23.982-107.392,126.566-107.392,126.566s-29.074-208.25-33.053-214.733",
    transform: "translate(-16119.272 8641.244)",
    fill: "#173943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path666",
    d: "M6778.039-5450.185a57.961,57.961,0,0,0-6.967,2.835,3.108,3.108,0,0,0-1.956-1.5,76.681,76.681,0,0,0-36.274-1.137c-4.278.88-2.469,7.431,1.809,6.551a68.445,68.445,0,0,1,29,.354,54.862,54.862,0,0,0-16.512,17.966,3.278,3.278,0,0,0-.782,1.124c-.2.465-.4.941-.611,1.406a58.5,58.5,0,0,0-3.056,7.113c-1.234,3.581,4.682,6.172,6.209,2.615q1.5-3.483,3.006-6.954a47.6,47.6,0,0,1,27.94-23.808c4.143-1.345,2.371-7.908-1.809-6.563",
    transform: "translate(-16129.982 8647.058)",
    fill: "#ed867e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path668",
    d: "M8319.133-5377c38.524-67.111,20.35-167.3,9.484-168.347-10.669-.99-17.11,42.093-17.477,44.256.073-1.5.929-26.729.464-53.386-.5-27.463-20.96-18.309-24.15,14.435-3.153,32.706-79.432,134.063-83.306,137.816-3.924,3.8,0,0,1.1-14.715,1.137-14.765,16.035-68.872,2.859-71.78-34.112-7.553-48.264,118.639-58.286,152.213-1.577,5.4-2.481,8.494-2.481,8.494,16.353,69.9,65.8,100.281,76.706,75.862,0,0,3.935-5.562,10.462-15.155,15.351-22.7,57.579-62.528,84.625-109.693",
    transform: "translate(-16248.077 8656.98)",
    fill: "#ffb0a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path670",
    d: "M151,83.1c2.259-3.638,3.089-11.658-1-11.586C126.675,71.907,82.746,36.68,68.859,0,67.41,5.307,0,133.9,0,133.9c7.8,47.4,23.908,65.783,38.243,73.359,28.335,18.347,56.142,11.322,56.142,11.322h0a209.6,209.6,0,0,0,21.573-43.055C127.731,143.249,148.189,87.611,151,83.1",
    transform: "matrix(0.999, -0.035, 0.035, 0.999, -8173.073, 3323.275)",
    fill: "#173943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path672",
    d: "M8260.048-5395.587c-7.8-2.554-32.633-10.56-38.328-1.026-2.981,4.975,1.81,11.574,3.789,15.84,2.652,5.683,5.463,11.379,7.211,17.416.758,2.616,3.813,13.872,2.054,18.883l-.185-.012a3.448,3.448,0,0,0-3.274,2.493c-.6,2.188-.27,3.324,1.222,5.023a3.473,3.473,0,0,0,4.119.526c9.275-4.743,4.437-23.222,1.992-30.568-1.124-3.385-2.493-6.7-3.936-9.96-1.234-2.824-5.183-8.005-5.023-10.792.635-11.232,22.623-3.227,28.551-1.271,4.168,1.369,5.952-5.194,1.809-6.551",
    transform: "translate(-16254.196 8642.852)",
    fill: "#ed867e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path674",
    d: "M7133.168-4409.089c8.078,35.285-3.545,661.677-3.545,661.677s513.118,101.846,650.078,0c0,0,55.585-765.711,24.053-756.874s-203.9-99.317-203.9-99.317L7471.84-4431.736l-172.233-161.575-166.439,184.223",
    transform: "translate(-16163.256 8576.379)",
    fill: "#357d93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path676",
    d: "M7670.967-4623.611l243.316-256.308,145.271-334.175,97.142,78.783L8080.21-4789.77s-294.93,411.907-288.708,404.99l-120.534-238.831",
    transform: "translate(-16208.374 8627.26)",
    fill: "#357d93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path678",
    d: "M6773.157-5148.058l93.229,350.418,268.6,414.706L7297.6-4511.583,7269.9-4642.444l-261.612-235.727L6902.2-5193.12l-129.04,45.062",
    transform: "translate(-16133.546 8625.512)",
    fill: "#357d93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path680",
    d: "M7315.062-4594.018s51.442-21.437,53.288-17.612c4.449,9.215,82.451,65.864,96.97,55.7,6.221-4.363,13.444,44.28,17.942,71.621,2.457,14.887,4.033,26.143,4.033,26.143v25.728l-172.233-161.575",
    transform: "translate(-16178.711 8577.085)",
    fill: "#357d93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path682",
    d: "M7521.987-4547.964s55.574-48.375,71.609-76.167h0a12.668,12.668,0,0,1,17.392-.049l19.824,18.578s-52.225,111-57.37,109.974-70.644,61.892-70.644,61.892l-1.724-37.313,20.912-76.914",
    transform: "translate(-16194.215 8578.38)",
    fill: "#357d93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path684",
    d: "M7465.9-4554.568a4.868,4.868,0,0,0-6.124,3.141c-9.863,30.616-26.375,37.607-49.757,37.753a4.945,4.945,0,0,0-1.943-1.43,199.472,199.472,0,0,1-93.718-80.787c-3.618-5.977-13.017-.513-9.374,5.475a208.842,208.842,0,0,0,97.617,84.687c.073.024.135.013.208.037a4.78,4.78,0,0,0,3.618,1.809c.94.025,1.894.025,2.835.025,23.943,0,47.385-6.148,59.778-44.586a4.864,4.864,0,0,0-3.141-6.124",
    transform: "translate(-16177.804 8575.951)",
    fill: "#e3dde8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path686",
    d: "M7632.715-4592.7c-8.592,11.305-16.806,23.112-26.143,33.831-2.921,3.349-26.644,23.234-26.681,23.173-2.309-3.288-6.367-2.8-8.665-.746a4.331,4.331,0,0,0-1.2-.2c-8.2.245-31.692-.892-41.934-8.848a4.868,4.868,0,0,0-6.832.855,4.889,4.889,0,0,0,.855,6.832c13.029,10.132,38.451,10.915,46.053,10.915,1.2,0,1.968-.013,2.151-.024a4.718,4.718,0,0,0,2.615-.966c18.15,14.569,62.052-49.988,69.165-59.35,4.229-5.561-5.206-10.976-9.386-5.476",
    transform: "translate(-16195.813 8575.661)",
    fill: "#e3dde8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path688",
    d: "M7504.991-4455.1c-.659-6.893-11.526-6.966-10.865,0,8.458,88,8.311,176.987,11.037,265.316.208,6.967,11.074,7,10.854,0-2.714-88.328-2.567-177.317-11.024-265.316",
    transform: "translate(-16193.634 8564.435)",
    fill: "#e3dde8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path690",
    d: "M7023.964-4831.912c-.734-2.163-2.775-4.143-5.231-3.984-3.557.208-7.065.635-10.548,1.125a5.537,5.537,0,0,0-6.38-3.813,68.542,68.542,0,0,0-30.763,14.629c-.024.013-.048.013-.073.024,0,.013,0,.013.013.013-.367.306-.758.538-1.112.843-5.06,4.253,1.381,10.89,6.575,8.519a118.349,118.349,0,0,1,38.133-10.046,29.94,29.94,0,0,1-3.068,21.169c-3.361,6.135,6.013,11.623,9.374,5.475a41.161,41.161,0,0,0,3.08-33.953",
    transform: "translate(-16149.788 8595.973)",
    fill: "#173943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path692",
    d: "M7997.943-4839.335a56.961,56.961,0,0,1-20.252-20.02,5.449,5.449,0,0,0-9.362.183c-.306-1.454-.635-2.9-.868-4.388-1.038-6.893-11.513-3.972-10.475,2.885a90.261,90.261,0,0,0,10.878,31.129c2.714,4.767,10.022,2.554,10.12-2.737.062-2.982.11-5.952.171-8.935a68.5,68.5,0,0,0,14.3,11.269c6.038,3.557,11.514-5.83,5.487-9.386",
    transform: "translate(-16232.206 8598.373)",
    fill: "#173943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path694",
    d: "M8622.846-5456.006c.612,19.262,2.849,36.788,7.407,50.978l-463.691,39.379s-16.146-22.647-29.883-55.867c-1.491-3.63-2.982-7.37-4.4-11.257-7.59-20.692-13.663-44.562-14.507-69.189-.049-1.161-.1-2.322-.086-3.482-.329-21.988,3.643-44.476,14.472-65.791,1.551-3.056,3.251-6.075,5.084-9.082a137.257,137.257,0,0,1,9.7-13.737,146.583,146.583,0,0,1,11.1-12.32,173.309,173.309,0,0,1,25.972-21l468.3-45s-3.079,12.087-7.284,31.459c-.795,3.679-1.613,7.6-2.506,11.757q-1.264,6.289-2.628,13.163c-.746,3.789-1.5,7.724-2.237,11.782-3.336,17.881-6.672,38.022-9.349,58.8-.489,3.862-.978,7.761-1.418,11.66a576.332,576.332,0,0,0-4.241,66.182c-.013,3.9.048,7.785.2,11.563",
    transform: "translate(-16245.604 8665.455)",
    fill: "#f9e4dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path696",
    d: "M8622.959-5437.385l-486.168,34.49-11.562.807a4.251,4.251,0,0,1-.892-.013,5.8,5.8,0,0,1-5.3-5.329,5.8,5.8,0,0,1,5.377-6.16l7.981-.563,490.372-34.8c-.013,3.9.049,7.786.2,11.563",
    transform: "translate(-16245.718 8646.834)",
    fill: "#edd1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path698",
    d: "M8628.289-5533.867c-.488,3.862-.978,7.761-1.418,11.66L8123.6-5486.519a4.487,4.487,0,0,1-.9-.024,5.686,5.686,0,0,1-4.949-3.875,4.465,4.465,0,0,1-.306-1.442,5.412,5.412,0,0,1,.22-2.041,5.747,5.747,0,0,1,5.121-4.131l505.5-35.835",
    transform: "translate(-16245.584 8653.911)",
    fill: "#edd1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path700",
    d: "M8647.2-5638.054c-.794,3.679-1.613,7.6-2.506,11.758l-494.785,35.078a3.487,3.487,0,0,1-.794.024l-.086-.012a5.79,5.79,0,0,1-5.292-5.354,5.772,5.772,0,0,1,5.354-6.159l11.122-.795,486.987-34.54",
    transform: "translate(-16247.776 8662.595)",
    fill: "#edd1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path702",
    d: "M8641.121-5610.866c-.746,3.789-1.5,7.724-2.237,11.781l-500.321,35.457c-.318,0-.611,0-.9-.013a5.863,5.863,0,0,1-4.278-2.468,5.757,5.757,0,0,1-1.014-2.872,5.791,5.791,0,0,1,5.377-6.16l.721-.049,502.656-35.676",
    transform: "translate(-16246.829 8660.329)",
    fill: "#edd1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path704",
    d: "M8038.232-5367.006,6545.481-5490.18a28.745,28.745,0,0,1-22.488-14.422c-50.086-87.314-41.567-165.927,19.42-247.692a32.609,32.609,0,0,1,28.807-12.943l138.463,10.877,103.069,8.127,1248.664,98.168c-88.451,82.975-89.795,177.5-23.185,281.058",
    transform: "translate(-16109.979 8673.204)",
    fill: "#4e6fd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path706",
    d: "M6775.558-5582.067a372.773,372.773,0,0,0,11.366,111.489l-96.456-7.957a466.51,466.51,0,0,1-7.149-108.128c3.067-61.66,17.587-118,42.4-166.7l103.068,8.127c-40.968,56.331-51.21,122.587-53.227,163.165",
    transform: "translate(-16126.01 8672.205)",
    fill: "#ffdaa9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path708",
    d: "M7895.276-5489.669a373.228,373.228,0,0,0,11.366,111.49l-96.444-7.969a465.689,465.689,0,0,1-7.15-108.116c3.056-61.66,17.587-118.016,42.4-166.708l103.056,8.14c-40.956,56.331-51.21,122.587-53.227,163.164",
    transform: "translate(-16219.334 8664.505)",
    fill: "#ffdaa9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path710",
    d: "M7038.914-5798.535l-429.9,36.836-49.658-4.2.012-.208c.367-3.361,23.393-7.8,26.889-8.116l451.409-38.683a7.3,7.3,0,0,1,3.141.428,7.261,7.261,0,0,1,4.657,6.148,7.214,7.214,0,0,1-6.551,7.8",
    transform: "translate(-16115.728 8677.17)",
    fill: "#889dba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path712",
    d: "M8537.9-5691.994l-483.87,52.946L6608.908-5761.66l-49.658-4.2-1.186-.1,1.2-.109,475.9-46.273a49.139,49.139,0,0,1,5.537-.1q.824.019,1.649.074L8537.9-5691.994",
    transform: "translate(-16115.619 8677.132)",
    fill: "#3448ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path714",
    d: "M8169.739-5334.708a7.218,7.218,0,0,1-6.587-6.613,7.209,7.209,0,0,1,6.612-7.773l477.136-38.242a7.2,7.2,0,0,1,7.773,6.612,7.207,7.207,0,0,1-6.612,7.761l-477.137,38.255a9.791,9.791,0,0,1-1.185,0",
    transform: "translate(-16249.394 8641.701)",
    fill: "#889dba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path716",
    d: "M8194.006-5628.774a7.218,7.218,0,0,1-6.588-6.612,7.21,7.21,0,0,1,6.612-7.774l477.137-38.242a7.2,7.2,0,0,1,7.772,6.612,7.2,7.2,0,0,1-6.611,7.761l-477.137,38.255a9.414,9.414,0,0,1-1.186,0",
    transform: "translate(-16251.416 8666.21)",
    fill: "#889dba"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeNeedYourHelp);
export default __webpack_public_path__ + "static/media/weNeedYourHelp.cdf6e0e24aeae1e6cad4c1cce056f6a6.svg";
export { ForwardRef as ReactComponent };